import script from "./discountCardList.vue?vue&type=script&setup=true&lang=js"
export * from "./discountCardList.vue?vue&type=script&setup=true&lang=js"

import "./discountCardList.vue?vue&type=style&index=0&id=821f1fc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-821f1fc0"]])

export default __exports__